import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveOverflow(theme, screenWidth, overflowSupport) {
    var result = {};
    if (overflowSupport.overflow !== undefined) {
        result.overflow = resolveResponsiveValue(theme, screenWidth, overflowSupport.overflow);
    }
    return result;
}
//# sourceMappingURL=OverflowResolver.js.map